import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { CoolLocalStorage } from 'angular2-cool-storage';
import {AngularFireDatabase,  FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2/database';


@Component({
  selector: 'page-records',
  templateUrl: 'records.html',
})
export class RecordsPage {

  key: any;
  name: any;
  localStorage: CoolLocalStorage;
  record: FirebaseListObservable<any[]>;

  constructor(private db: AngularFireDatabase, localStorage: CoolLocalStorage, public navCtrl: NavController, public navParams: NavParams) {

    this.key = navParams.get('item');
    this.name = navParams.get('name');
    this.localStorage = localStorage;

    this.record = db.list('v2/record/' + this.localStorage.getItem('code') + "/" + this.key)


  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad RecordsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/records/records.ts